import { createSlice } from '@reduxjs/toolkit'

export const sessionSlice = createSlice({
	name: 'auth/session',
	initialState: {
        token: '',
        signedIn: false,
        isUserEmailVerified:false,
        isUserOtpVerified: false,
        authData: null,
    },
	reducers: {
        onSignInSuccess: (state, action) => {
            state.signedIn = true
            state.token = action.payload
        },
        onSignOutSuccess: (state) => {
            state.signedIn = false
            state.token = ''
            state.isUserEmailVerified = false
        },
        setToken: (state, action) =>  {
            state.token = action.payload
        },
        setIsUserEmailVerified:(state, action)=>{
            state.isUserEmailVerified = action.payload
        },
        setUserOtpValidation: (state, action) => {
            state.isUserOtpVerified = action.payload
        },
        setAuthData: (state, action) => {
            state.authData = action.payload;
        },
        clearAuthData: (state) => {
            state.authData = null;
        },
	},
})

export const { onSignInSuccess, onSignOutSuccess, setToken, setIsUserEmailVerified, setUserOtpValidation,  setAuthData, clearAuthData } = sessionSlice.actions

export default sessionSlice.reducer